export const SIDEBAR_RIGHT_PANE_GRID = 'sidebar-right-pane';
export const SIDEBAR_CONTENT_GRID = 'sidebar-content';
export const SIDEBAR_TOP_BAR_GRID = 'sidebar-top';
export const SIDEBAR_INSET_GRID = 'sidebar-inset';

export const Z_INDEX_MOBILE_OVERLAY = 100000;
export const Z_INDEX_MOBILE_SIDEBAR = Z_INDEX_MOBILE_OVERLAY + 1;
export const Z_INDEX_MOBILE_MENU = Z_INDEX_MOBILE_SIDEBAR + 1;
export const Z_INDEX_MOBILE_UPSELL = Z_INDEX_MOBILE_MENU + 1;
export const Z_INDEX_MOBILE_VIDEO = Z_INDEX_MOBILE_UPSELL + 1;
export const Z_INDEX_ASSISTANT_BUTTON = 1199;

export const MIN_WIDTH_EXPANDED_SIDEBAR = '166px';

export const SIDEBAR_WIDTH_EXPANDED = 232;
export const SIDEBAR_WIDTH_COLLAPSED = 65;
export const INTERCOM_SIDEBAR_GAP = 16;

export const SIDEBAR_ASSISTANT_PANEL_GRID = 'sidebar-assistant-panel';
export const ASSISTANT_PANEL_WIDTH_CSS_VAR = '--assistant-panel-width';
export const ASSISTANT_PANEL_DEFAULT_WIDTH = 428;
export const ASSISTANT_PANEL_MIN_WIDTH = 360;
export const ASSISTANT_PANEL_MAX_WIDTH = 640;
